export default "__VITE_ASSET__B6C6jKw4__"